// src/infrastructure/IconProvider.js
import { Icon } from '@iconify/react';
import pieChart2Fill from '@iconify/icons-eva/pie-chart-2-fill';
import peopleFill from '@iconify/icons-eva/people-fill';
import motoFill from '@iconify/icons-eva/car-outline';
import infoFill from '@iconify/icons-eva/info-outline';
import videoFill from '@iconify/icons-eva/video-outline';
import LogoutIcon from '@iconify/icons-eva/log-out-outline';
import healthcareIcon from '@iconify/icons-iconoir/healthcare';
import emissionIcon from '@iconify/icons-carbon/carbon-accounting';

const iconMap = {
    pieChart2Fill,
    peopleFill,
    motoFill,
    infoFill,
    videoFill,
    LogoutIcon,
    healthcareIcon,
    emissionIcon
};

export const getIcon = (name) => iconMap[name] ? <Icon icon={iconMap[name]} width={22} height={22} /> : null;